import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { Logo } from "../components/Logo";

export default function ForgotPassword() {
  const { lang } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email, lang });
      setMsg(data.message || "Si un compte existe pour cet email, un lien de réinitialisation vient d'être envoyé.");
      setDone(true);
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="pt-40 pb-32 min-h-[80vh] flex flex-col items-center px-6">
      <div className="mb-10"><Logo size="md" /></div>
      <div className="card-lux p-10 w-full max-w-md">
        <h1 className="font-display text-4xl mb-4 text-center" style={{ fontWeight: 300 }}>Mot de passe oublié</h1>
        {done ? (
          <div data-testid="forgot-success">
            <p className="text-sm text-center leading-relaxed mb-8" style={{ color: "var(--lo-muted)" }}>{msg}</p>
            <Link to="/connexion" className="btn-primary h-14 w-full inline-flex items-center justify-center" data-testid="forgot-back-login">Retour à la connexion</Link>
          </div>
        ) : (
          <>
            <p className="text-sm text-center leading-relaxed mb-8" style={{ color: "var(--lo-muted)" }}>
              Entrez votre adresse e-mail. Si un compte existe, vous recevrez un lien pour définir un nouveau mot de passe.
            </p>
            <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
              <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border-b py-3 text-sm outline-none" style={{ borderColor: "var(--lo-border)" }} data-testid="forgot-email" />
              {err && <p className="text-xs" style={{ color: "#e08" }} data-testid="forgot-error">{err}</p>}
              <button disabled={busy} className="btn-primary h-14 w-full disabled:opacity-50" data-testid="forgot-submit">{busy ? "..." : "Envoyer le lien"}</button>
            </form>
            <p className="text-center text-sm mt-6" style={{ color: "var(--lo-muted)" }}>
              <Link to="/connexion" className="link-underline" style={{ color: "var(--lo-rose-hi)" }} data-testid="forgot-login-link">Retour à la connexion</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
